"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactBeautifulDnd = require("react-beautiful-dnd");

var _withTheme = require("../../wrappers/with-theme");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var DraggableItem = function DraggableItem(_ref) {
  var id = _ref.id,
      index = _ref.index,
      children = _ref.children;
  return /*#__PURE__*/_react["default"].createElement(_reactBeautifulDnd.Draggable, {
    draggableId: "draggable-".concat(id),
    index: index
  }, function (provided) {
    return /*#__PURE__*/_react["default"].createElement("div", _extends({
      ref: provided.innerRef,
      className: "flex"
    }, provided.draggableProps, provided.dragHandleProps), /*#__PURE__*/_react["default"].createElement("div", {
      className: "flex-1"
    }, children));
  });
};

var DndList = function DndList(_ref2) {
  var onDrop = _ref2.onDrop,
      children = _ref2.children;

  var onDragEnd = _react["default"].useCallback(function (result) {
    if (!result.destination) return;
    var start = result.source.index,
        end = result.destination.index;
    if (start === end) return;
    onDrop(start, end);
  }, [onDrop]);

  var theme = (0, _withTheme.useTheme)();
  return /*#__PURE__*/_react["default"].createElement(_reactBeautifulDnd.DragDropContext, {
    onDragEnd: onDragEnd
  }, /*#__PURE__*/_react["default"].createElement(_reactBeautifulDnd.Droppable, {
    droppableId: "my-list",
    className: "box-content"
  }, function (provided, snapshot) {
    return /*#__PURE__*/_react["default"].createElement("div", _extends({
      ref: provided.innerRef
    }, provided.droppableProps, {
      className: "flex flex-col\n                ".concat(snapshot.isDraggingOver ? theme.listDragging : theme.list, "\n              ")
    }), /*#__PURE__*/_react["default"].createElement("div", null, _react["default"].Children.toArray(children).map(function (child, i) {
      return /*#__PURE__*/_react["default"].createElement(DraggableItem, {
        key: child.key,
        id: child.key,
        index: i
      }, child);
    })), provided.placeholder);
  }));
};

DndList.defaultProps = {
  items: [],
  idAccessor: function idAccessor(d) {
    return d.id;
  },
  indexAccessor: function indexAccessor(d) {
    return d.index;
  },
  onDrop: function onDrop(start, end) {}
};
var _default = DndList;
exports["default"] = _default;